<template>
    <div class="resource-booking-box flex-fill border rounded mb-4">
        <div class="content row no-gutters">
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-auto pr-0">
                        <img class="resource-img border border-light p-1 m-2" :src="getImageSrc" />
                    </div>
                    <div class="col pl-0">
                        <div class="m-2">
                            <h5 class="mb-0">{{ resource.name | properCase }}</h5>
                            <h6 class="text-muted mb-3">{{ resource.title ? `Specializzazione in ${resource.title}` : '' }}</h6>
                            <h6>{{ service.name }}{{getAdditionalServicesDescription}}</h6>
                            <h6 v-html="getPriceRow"></h6>
                            <h6>Durata: <span class="font-weight-normal">{{ service.duration }} min</span></h6>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="p-3" style="white-space: pre-wrap;">{{ resource.description }}</div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 border-lg-left">
                <div class="row m-2 d-flex flex-row align-content-start"
                    v-if="presences.length"
                    >
                    <div class="day-column col-sm px-2 border-top border-sm-0 mb-2"
                        :class="{ 'd-none d-sm-block': !dayPresences.length }"
                        v-for="(dayPresences, date) in getDatesByDay"
                        v-bind:key="date"
                        >
                        <div class="day-column-title clearfix">
                            <div class="d-none d-sm-block text-center">{{ date | moment("ddd") | capitalize}}</div>
                            <div class="d-none d-sm-block text-center text-muted">{{ date | moment("DD") }} {{ date | moment("MMM") | capitalize }}</div>

                            <div class="d-sm-none text-center big font-weight-bold pt-2">{{ date | moment("DD")}} {{ date | moment("MMMM") | capitalize }} - {{ date | moment("dddd") | capitalize}}</div>
                        </div>
                        <div class="day-column-availabilities d-flex flex-column">
                            <resource-booking-box-button
                                class="text-center align-self-start"
                                v-for="(presence, index) in dayPresences"
                                v-bind:key="index"
                                v-bind:headquarterId="presence.headquarterId"
                                v-bind:startDate="presence.startDate"
                                v-bind:endDate="presence.endDate"
                                v-bind:maxSlotDuration="presence.maxSlotDuration"
                                v-on:book-resource="bookResource"
                            />
                        </div>
                    </div>
                </div>
                <div class="row m-2 d-flex flex-row align-content-start"
                    v-else-if="firstDayPresence"
                    >
                    <resource-booking-box-next-availability-button
                        class="text-center align-self-start col"
                        v-bind:moveToDate="firstDayPresence"
                        v-on:change-date="changeDate"
                    />
                </div>
                <div class="row m-2 d-flex flex-row align-content-start"
                    v-else
                    >
                    <div class="text-center align-self-start col alert alert-danger">Nessuna disponibilità trovata nei prossimi giorni</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import moment from 'moment';

export default {
    components: {
    },
    data() {
        return {
        };
    },
    props: {
        instanceId: VueTypes.number.def(undefined),
        resource: VueTypes.object,
        headquarter: VueTypes.object,
        service: VueTypes.object,
        resourceServices: VueTypes.object,
        presences: VueTypes.array,
        firstDayPresence: VueTypes.date,
        filterDate: VueTypes.date,
        filterType: VueTypes.string,
        displayDaysRange: VueTypes.number,
    },
    computed: {
        getImageSrc() {
            return this.resource.imageUrl || defaultProfileImage;
        },
        getAdditionalServicesDescription() {
            let description = "";
            if (this.filterType == "service_category") {
                let countServices = Object.keys(this.resourceServices).length;
                if (countServices > 1) {
                    let additionalServices = countServices - 1;
                    if (additionalServices == 1) {
                        description = " (+" + additionalServices + " altra prestazione disponibile)";
                    } else {
                        description = " (+" + additionalServices + " altre prestazioni disponibili)";
                    }
                }
            }
            return description;
        },
        getDatesByDay() {
            let days = {};
            let currentDay = moment(this.filterDate);
            for (let key = 0; key < this.displayDaysRange; key++) {
                days[currentDay.format("YYYY-MM-DD")] = [];
                currentDay.add(1, 'day');
            }
            for (let key in this.presences) {
                let presence = this.presences[key];
                if (typeof days[moment(presence.startDate).format("YYYY-MM-DD")] == "object") {
                    days[moment(presence.startDate).format("YYYY-MM-DD")].push(presence);
                }
            }

            return days;
        },
        getPriceRow() {
            let row = "Prezzo: <span class=\"font-weight-normal\">" + this.service.price + "€";
            if (this.service.vatRate > 0) {
                row += " IVA Inc.";
            }
            if (this.service.bookingPrice != this.service.price) {
                row += " (caparra: " + this.service.bookingPrice + "€)";
            } else {
                row += " (pagamento anticipato)";
            }
            row += "</span>";

            return row;
        }
    },
    filters: {
        properCase(string) {
            if (typeof string == "string") {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else {
                return "";
            }
        },
    },
    methods: {
        bookResource(startDate, maxSlotDuration, headquarterId) {
            // this.$emit('setLoadingBookingDialog', true);
            let params = {
                resource: this.resource,
                headquarter: this.headquarter,
                service: this.service,
                resourceServices: this.resourceServices,
                headquarter_id: headquarterId,
                book_date_time: startDate,
                max_slot_duration: maxSlotDuration,
            };
            this.$emit('setBookingPopupData', params);
        },
        changeDate(date) {
            this.$emit('set-date', date);
        },
    },
};
</script>

<style lang="scss">
.resource-booking-box {

    .resource-img {
        height: 100px;
        width: 100px;
    }
    .resource-img {
        object-fit: cover;
    }

    .day-column-availabilities {
        .btn {
            width: 100%;
            line-height: 0.8em;
        }
    }

    h6 {
        line-height: 1.1em;
        padding-bottom: 0.4em;
    }
    /*
    @media screen and (max-width: 575px) {
        .day-column-title > div {
            display: inline-block;
            font-size: 1.2em
        }
    }
    */
}
</style>
